import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ErrorModel } from '../common/error.model';
import { SignDto } from '../common/model/sign/sign-dto';
import { ExtraService } from '../common/api/extra.service';
import { UserService } from '../common/api/user.service';
import { Sign } from '../common/model/sign/sign.model';

@Component({
  selector: 'app-sign',
  templateUrl: './sign.component.html',
  styleUrls: ['./sign.component.css']
})
export class SignComponent implements OnInit {

  modalSrc = 'image/loading.gif';
  sign: Sign = new Sign();
  signDto: SignDto = new SignDto();
  imageCase = '_all';

  popTitle = '';
  result = '';
  fontStyle = 'Noto Sans KR, sans-serif';

  signForm: FormGroup = new FormGroup({
    name: new FormControl('', Validators.compose([validRequired])),
    email: new FormControl('', Validators.compose([validRequired])),
    position : new FormControl('', Validators.compose([validRequired])),
    department : new FormControl('', Validators.compose([validRequired])),
    mobileNumber1 : new FormControl('', Validators.compose([validRequired])),
    mobileNumber2 : new FormControl('', Validators.compose([validRequired])),
    mobileNumber3 : new FormControl('', Validators.compose([validRequired])),
    officeNumber1 : new FormControl('', Validators.compose([validRequired])),
    officeNumber2 : new FormControl('', Validators.compose([validRequired])),
    officeNumber3 : new FormControl('', Validators.compose([validRequired])),
    extensionNumber1 : new FormControl('', Validators.compose([validRequired])),
    extensionNumber2 : new FormControl('', Validators.compose([validRequired])),
    extensionNumber3 : new FormControl('', Validators.compose([validRequired]))
  });

  constructor(private userService: UserService, private extraService: ExtraService) { }

  ngOnInit() {
  }

  /**
  * 서명 만들기 요청
  */
  makeSign() {

      if (!this.signForm.controls['name'].errors.valid) {
        alert('(이름) ' + this.signForm.controls['name'].errors.errorMsg);
        return;
      }

      if (!this.signForm.controls['position'].errors.valid) {
        alert('(직함) ' + this.signForm.controls['position'].errors.errorMsg);
        return;
      }

      if (!this.signForm.controls['department'].errors.valid) {
        alert('(부서) ' + this.signForm.controls['department'].errors.errorMsg);
        return;
      }

      if (!this.signForm.controls['mobileNumber1'].errors.valid
      || !this.signForm.controls['mobileNumber2'].errors.valid
      || !this.signForm.controls['mobileNumber3'].errors.valid) {
        alert('(휴대폰 번호) 필수 정보입니다.');
        return;
      }

      if (!this.signForm.controls['extensionNumber1'].errors.valid
        || !this.signForm.controls['extensionNumber2'].errors.valid
        || !this.signForm.controls['extensionNumber3'].errors.valid) {
        alert('(내선 번호) 필수 정보입니다.');
        return;
      }

      if (!this.signForm.controls['officeNumber1'].errors.valid
        || !this.signForm.controls['officeNumber2'].errors.valid
        || !this.signForm.controls['officeNumber3'].errors.valid) {
        alert('(팩스 번호) 필수 정보입니다.');
        return;
      }

      if (!this.signForm.controls['email'].errors.valid) {
        alert('(이메일) ' + this.signForm.controls['email'].errors.errorMsg);
        return;
      }

      this.extraService.makeSignature(this.signDto).subscribe(response => {
          this.sign = response.json();
          let count = 0;
          window.scrollTo(0, 0);
          const checkInterval = setInterval(() => {
            this.checkStatus(this.sign.signNo, checkInterval);
            count++;

            if (count > 20) {
                clearInterval(checkInterval);
                alert('응답시간을 초과하였습니다.');
                $('#modalClose').click();
            }

          }, 500);

          $('#modalClick').click();
      });
  }

  /**
  * 폼 초기화
  */
  reset() {
    this.signDto = new SignDto();
  }

  valueChange($event) {
      const KOR_REGEXP = /^[가-힣ㄱ-ㅎ]+$/;
      if (!KOR_REGEXP.test($event.target.value)) {
        $event.target.value = '';
      }
  }

  copyLink() {
      alert('복사되었습니다.');
  }

  checkStatus(signNo, interval) {
    this.extraService.getSignImageStatus(signNo).subscribe(response => {
      const status = response.json();

      if (status === 'CONVERTING') {
          if (this.modalSrc !== 'image/loading.gif') {
              this.modalSrc = 'image/loading.gif';
          }
          this.popTitle = '서명을 생성 중입니다.';
      } else if (status === 'COMPLETE') {
          this.getSignInfo(signNo);
          clearInterval(interval);
      } else if (status === 'ERROR') {
          clearInterval(interval);
          alert('생성 중 오류가 발생했습니다.');
      }
      }
     );

  }

  getSignInfo(signNo) {
    this.extraService.getSignImage(signNo).subscribe(response => {
      if (response.status === 200) {
        this.sign = response.json();
        this.modalSrc = this.sign.url;

        console.log(this.sign.sinkUrl);
        this.popTitle = this.sign.name + '님의 서명이 생성되었습니다.';
      }
    }, error => {
      if (error.status === 401) {
        alert('로그인이 만료되었거나 잘못된 인증입니다.\n다시 로그인 해주세요');
        this.userService.logout();
      } else {
        alert('오류가 발생했습니다.');
      }
    });
  }

}

/**
 * element 입력 여부 체크
 */
function validRequired(ele: FormControl) {

  if (ele.value === '') {
      return {
        valid: false,
        errorMsg: '필수 정보입니다.'
      };
  }  else {
    return {
      valid: true,
      errorMsg: ''
    };
  }

}

function validName(ele: FormControl) {
    if (ele.value === '') {
        return {
          valid: false,
          errorMsg: '필수 정보입니다.'
        };
    }

    if (ele.value.length > 5) {
        return {
          valid: false,
          errorMsg: '최대 5글자까지 입력 가능합니다.'
        };
    }

    const KOR_REGEXP = /^[가-힣ㄱ-ㅎ]+$/;
    return KOR_REGEXP.test(ele.value) ? {
        valid : true,
        errorMsg : ''
    } : {
        valid : false,
        errorMsg : '한글 외에는 입력할 수 없습니다.'
    };

}

function validDept(ele: FormControl) {
    if (ele.value === '') {
        return {
          valid: false,
          errorMsg: '필수 정보입니다.'
        };
    }

    if (ele.value.length > 15) {
        return {
          valid: false,
          errorMsg: '최대 15글자까지 입력 가능합니다.'
        };
    }

    const KOR_REGEXP = /^[가-힣ㄱ-ㅎ]+$/;
    return KOR_REGEXP.test(ele.value) ? {
        valid : true,
        errorMsg : ''
    } : {
        valid : false,
        errorMsg : '한글 외에는 입력할 수 없습니다.'
    };

}

/**
 * email validation check
 * @param email
 */
function validEmail(email: FormControl) {

    if (email.value === '') {
      return {
        valid: false,
        errorMsg: '필수 정보입니다.'
      };
    }

    const EMAIL_REGEXP = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
    return EMAIL_REGEXP.test(email.value) ? {
      valid: true,
      errorMsg: ''
    } : {
      valid: false,
      errorMsg: '잘못된 이메일 형식입니다.'
    };

}




// WEBPACK FOOTER //
// /home/gitlab-runner/builds/d90c5bcf/0/gaia/gaia-ui-angular/src/app/sign/sign.component.ts